import axios from 'axios'
import moment from 'moment'

import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  namespaced: true,
  state() {
    return {
      company_rates: {},
      is_rates_expired: false,
      is_rates_started: true
    }
  },
  mutations: {
    set_rates_list: (state, rates) => {
      state.company_rates = rates;
    },

    check_rates_expired: (state, rates) => {
      if (!rates || (!rates.paid_to && rates.paid_to !== null)) {
        state.is_rates_expired = true;
        return;
      }

      if (rates.paid_to === null) {
        state.is_rates_expired = false
        return;
      }

      const diffDays = moment(rates.paid_to).diff(moment().startOf('day'), 'days') + 1;

      const isExpired = diffDays <= 0

      state.is_rates_expired = isExpired
      state.is_rates_started = rates.paid_from ? moment(rates.paid_from).startOf('day').diff(moment().startOf('day'), 'days') <= 0 : true;

      if (!state.is_rates_started) {
        state.is_rates_expired = true
      }
    }
  },
  actions: {
    get_company_rates(context, { id }) {
      return axios.get(`/1.0/admin/company-limits`, {
        params: {
          active: 1,
          company_id: id
        }
      })
        .then(response => {
          const rates = parseResponse(response).data[0];
          context.commit('check_rates_expired', rates);
          context.commit('set_rates_list', rates);
        })
        .catch(err => handleError(err));
    },

    update_company_rates (context, {params, id}) {
      return axios.put('/1.0/admin/company-limits', {limits: [params]})
        .then(response => {
          return response;
        })
        .catch(err => {
          throw new Error(handleError(err).message);
        })
    },

    create_company_rates (context, {params, id}) {
      return axios.post('/1.0/admin/company-limits', {limits: [params]})
        .then(response => {
          return response;
        })
        .catch(err => {
          throw new Error(handleError(err).message);
        })
    }
  },
  getters: {
    company_rates: state => state.company_rates
  }
}